import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Lock, Menu, X, ChevronDown } from 'lucide-react';
import logo from '../assets/mrtp-logo.png';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [maisonDropdownOpen, setMaisonDropdownOpen] = useState(false);
  const [conseilsDropdownOpen, setConseilsDropdownOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src={logo}
              alt="MRTP SARL"
              className="h-16 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {/* Dropdown Menu for Votre projet */}
            <div 
              className="relative group"
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
            >
              <button className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium flex items-center py-2">
                Votre projet
                <ChevronDown className={`w-4 h-4 ml-1 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {/* Dropdown Menu */}
              {dropdownOpen && (
                <div className="absolute top-full left-0 pt-2 w-64 z-50">
                  <div className="bg-white rounded-lg shadow-xl border border-gray-100 py-2 animate-fadeInDown">
                    <Link
                      to="/projet-construction"
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#c4d600] transition-all duration-200 rounded-md mx-1"
                    >
                      <div className="font-semibold text-sm">Projet de construction</div>
                      <div className="text-xs text-gray-500 mt-1">Notre accompagnement complet</div>
                    </Link>
                    <div className="border-t border-gray-100 my-1"></div>
                    <Link
                      to="/etapes-construction"
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#c4d600] transition-all duration-200 rounded-md mx-1"
                    >
                      <div className="font-semibold text-sm">Étapes de construction</div>
                      <div className="text-xs text-gray-500 mt-1">Découvrez chaque étape</div>
                    </Link>
                  </div>
                </div>
              )}
            </div>
            
            {/* Dropdown Menu for Votre maison */}
            <div 
              className="relative group"
              onMouseEnter={() => setMaisonDropdownOpen(true)}
              onMouseLeave={() => setMaisonDropdownOpen(false)}
            >
              <button className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium flex items-center py-2">
                Votre maison
                <ChevronDown className={`w-4 h-4 ml-1 transition-transform ${maisonDropdownOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {/* Dropdown Menu */}
              {maisonDropdownOpen && (
                <div className="absolute top-full left-0 pt-2 w-64">
                  <div className="bg-white rounded-lg shadow-xl border border-gray-100 py-2 animate-in fade-in slide-in-from-top-2 duration-200">
                    <Link
                      to="/modeles"
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#c4d600] transition-colors"
                    >
                      <div className="font-semibold text-sm">Nos modèles</div>
                      <div className="text-xs text-gray-500 mt-1">75 modèles de maisons</div>
                    </Link>
                    <div className="border-t border-gray-100 my-1"></div>
                    <Link
                      to="/maisons-sur-mesure"
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#c4d600] transition-colors"
                    >
                      <div className="font-semibold text-sm">Maisons sur-mesure</div>
                      <div className="text-xs text-gray-500 mt-1">Personnalisation complète</div>
                    </Link>
                    <div className="border-t border-gray-100 my-1"></div>
                    <Link
                      to="/maison-biosourcee"
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#c4d600] transition-colors"
                    >
                      <div className="font-semibold text-sm">Maison biosourcée</div>
                      <div className="text-xs text-gray-500 mt-1">Écologique et durable</div>
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <Link to="/nos-terrains" className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium">
              Nos terrains
            </Link>
            <Link to="/nos-agences" className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium">
              Nos agences
            </Link>
            
            {/* Dropdown Menu for Nos conseils */}
            <div 
              className="relative group"
              onMouseEnter={() => setConseilsDropdownOpen(true)}
              onMouseLeave={() => setConseilsDropdownOpen(false)}
            >
              <button className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium flex items-center py-2">
                Nos conseils
                <ChevronDown className={`w-4 h-4 ml-1 transition-transform ${conseilsDropdownOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {/* Dropdown Menu */}
              {conseilsDropdownOpen && (
                <div className="absolute top-full left-0 pt-2 w-64">
                  <div className="bg-white rounded-lg shadow-xl border border-gray-100 py-2 animate-in fade-in slide-in-from-top-2 duration-200">
                    <Link
                      to="/nos-conseils"
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#c4d600] transition-colors"
                    >
                      <div className="font-semibold text-sm">Nos conseils</div>
                      <div className="text-xs text-gray-500 mt-1">Articles et actualités</div>
                    </Link>
                    <div className="border-t border-gray-100 my-1"></div>
                    <Link
                      to="/newsletter"
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#c4d600] transition-colors"
                    >
                      <div className="font-semibold text-sm">Newsletter</div>
                      <div className="text-xs text-gray-500 mt-1">Abonnez-vous</div>
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <Link to="/a-propos" className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium">
              À propos
            </Link>
            <Link to="/espace-client" className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium flex items-center">
              <Lock className="w-4 h-4 mr-1" />
              Espace client
            </Link>
            <Link
              to="/contact"
              className="bg-[#c4d600] text-gray-800 px-6 py-2.5 rounded hover:bg-[#b0c200] transition-colors text-sm font-semibold"
            >
              Contactez-nous
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            className="lg:hidden text-gray-700 p-2 hover:text-[#c4d600] transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`lg:hidden pb-4 overflow-hidden transition-all duration-300 ease-in-out ${
          mobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}>
          {mobileMenuOpen && (
            <nav className="flex flex-col space-y-3 animate-fadeInDown">
              {/* Mobile Dropdown for Votre projet */}
              <div>
                <button 
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium py-2 flex items-center w-full"
                >
                  Votre projet
                  <ChevronDown className={`w-4 h-4 ml-1 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                {dropdownOpen && (
                  <div className="ml-4 mt-2 space-y-2">
                    <Link 
                      to="/projet-construction" 
                      className="block text-gray-600 hover:text-[#c4d600] transition-colors text-sm py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Projet de construction
                    </Link>
                    <Link 
                      to="/etapes-construction" 
                      className="block text-gray-600 hover:text-[#c4d600] transition-colors text-sm py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Étapes de construction
                    </Link>
                  </div>
                )}
              </div>
              
              {/* Mobile Dropdown for Votre maison */}
              <div>
                <button 
                  onClick={() => setMaisonDropdownOpen(!maisonDropdownOpen)}
                  className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium py-2 flex items-center w-full"
                >
                  Votre maison
                  <ChevronDown className={`w-4 h-4 ml-1 transition-transform ${maisonDropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                {maisonDropdownOpen && (
                  <div className="ml-4 mt-2 space-y-2">
                    <Link 
                      to="/modeles" 
                      className="block text-gray-600 hover:text-[#c4d600] transition-colors text-sm py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Nos modèles
                    </Link>
                    <Link 
                      to="/maisons-sur-mesure" 
                      className="block text-gray-600 hover:text-[#c4d600] transition-colors text-sm py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Maisons sur-mesure
                    </Link>
                    <Link 
                      to="/maison-biosourcee" 
                      className="block text-gray-600 hover:text-[#c4d600] transition-colors text-sm py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Maison biosourcée
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/nos-terrains" className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium py-2">
                Nos terrains
              </Link>
              <Link to="/nos-agences" className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium py-2">
                Nos agences
              </Link>
              
              {/* Mobile Dropdown for Nos conseils */}
              <div>
                <button 
                  onClick={() => setConseilsDropdownOpen(!conseilsDropdownOpen)}
                  className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium py-2 flex items-center w-full"
                >
                  Nos conseils
                  <ChevronDown className={`w-4 h-4 ml-1 transition-transform ${conseilsDropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                {conseilsDropdownOpen && (
                  <div className="ml-4 mt-2 space-y-2">
                    <Link 
                      to="/nos-conseils" 
                      className="block text-gray-600 hover:text-[#c4d600] transition-colors text-sm py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Nos conseils
                    </Link>
                    <Link 
                      to="/newsletter" 
                      className="block text-gray-600 hover:text-[#c4d600] transition-colors text-sm py-2"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Newsletter
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/a-propos" className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium py-2">
                À propos
              </Link>
              <Link to="/espace-client" className="text-gray-700 hover:text-[#c4d600] transition-colors text-sm font-medium py-2 flex items-center">
                <Lock className="w-4 h-4 mr-1" />
                Espace client
              </Link>
              <Link
                to="/contact"
                className="bg-[#c4d600] text-gray-800 px-6 py-2.5 rounded hover:bg-[#b0c200] transition-colors text-sm font-semibold text-center mt-2"
              >
                Contactez-nous
              </Link>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;